import React from 'react'
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../../components/grid-container/GridContainer"
import { UiTopBgSlider, UiTopBgSliderLeftContent, UiInnerTopBgSlider,UiTopInnerBgLearnSlider } from "../../../components/common/UiTopBgSliderElements"
import SliderHeart from "../../../../../styles/img/slider-heart-icon.png";
import UiInnerTopSliderCard from "../../../components/common/UiInnerTopSliderCard"
import { UiSliderImageCard } from '../../../components/common/UiSliderImageCard';
import {UiButtonPrimary} from '../../../components/form/UiButton';
import ToyotaInnerLogo from '../../../../../styles/img/toyota-inner-logo.png';
import ToyotaInnerBannerQuiz from '../../../../../styles/img/knowledge-inner-quiz.png'

export default function KnowledgeInnerBannerQuiz(props) {

    return (
        <>
            <UiInnerTopBgSlider>
                <UiTopInnerBgLearnSlider bgImage={ToyotaInnerBannerQuiz}>
                    <UiSingleRow className={props.className}>
                        <UiCol lg="8">
                            <UiTopBgSliderLeftContent>
                                <div className='sb-top-inner-slider-status-wr'>
                                   <div className='sb-top-inner-slider-status'>
                                      {props.badges && <div> <span></span> Badges </div>}
                                      {props.courses && <div> <span></span> Courses </div>}
                                    </div>  
                                </div>
                                <h2>{props.title}</h2>
                                <p className='sb-top-bg-slider__slider-content__description'>{props.description}</p>
                                {props.courses && <div className='sb-top-slider-bottom-content'>
                                    <h4>{props.points} Points</h4>
                                    <UiButtonPrimary btnName="Open" size="45"/>
                                </div> }
                                
                              
                            </ UiTopBgSliderLeftContent>
                        </UiCol>
                        <UiCol lg="4" className="mt-3">
                            <img src={ToyotaInnerLogo}/>
                            {/* <UiSliderImageCard
                                image={props.sliderCardImage}
                                content={props.content}
                                contentTitle={props.contentTitle}
                                contentDedsc={props.contentDedsc}
                                contentTopLeftAlign={props.contentTopLeftAlign}
                            /> */}
                        </UiCol>
                    </UiSingleRow>
                </UiTopInnerBgLearnSlider>
            </UiInnerTopBgSlider>
        </>
    )
}
